import { ApolloLink, fromPromise } from '@apollo/client';
import { getAuthCheck } from '@lingoda/auth';

interface Params {
    onUnauthorized: () => void;
}

export const getAuthRestLink = (params: Params) =>
    new ApolloLink((operation, forward) => {
        return fromPromise(getAuthCheck('', params.onUnauthorized)).flatMap(() => {
            return forward(operation);
        });
    });
